import { render, staticRenderFns } from "./pointsSet.vue?vue&type=template&id=508a2eb0&scoped=true&"
import script from "./pointsSet.vue?vue&type=script&lang=js&"
export * from "./pointsSet.vue?vue&type=script&lang=js&"
import style0 from "./pointsSet.vue?vue&type=style&index=0&id=508a2eb0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "508a2eb0",
  null
  
)

export default component.exports